import axios from "axios";
import ClientOAuth2 from "client-oauth2";
import Settings from "./config";
import { getApiEndpoint, getIdentityEndpoint } from "./utilities";

let githubAuth = new ClientOAuth2({
  clientId: "rockliffehall.website",
  clientSecret: "b8919bea-8035-4001-9c08-c6af555d57c8",
  accessTokenUri: getIdentityEndpoint() + Settings.ACCESSTOKENURI,
  authorizationUri: getIdentityEndpoint() + Settings.AUTHORIZATIONURL,
  scopes: [
    "openid",
    "profile",
    "email",
    "rockliffehall.api",
    "rockfliffe.user",
    "offline_access",
  ],
});

export default {
  login(username, password, cb, fail) {
    githubAuth.owner
      .getToken(username, password)
      .then(function (user) {
        cb(user);
      })
      .catch(function (response) {
        console.log(response);
        let body = response.body.error_description;

        let payload = { emailAddress: username };
        axios
          .post(getApiEndpoint() + "api/member/initiate-migration", payload)
          .then((response) => {
            fail("member_migration_initiated");
          })
          .catch((err) => {
            fail(body);
          });
      });
  },
  validateMigration(payload, cb, fail) {
    axios
      .post(getApiEndpoint() + "api/member/validate-migration", payload)
      .then((response) => {
        cb(response.data);
      })
      .catch((err) => {
        fail("not_found");
      });
  },
  refreshToken(token, cb, fail) {
    token
      .refresh()
      .then(function (token) {
        cb(token);
      })
      .catch(function (response) {
        fail(response.body.error_description);
      });
  },
  async register(payload, cb, fail) {
    try {
      const emailResponse = await axios.post(
        `${Settings.WWWENDPOINT}/verifyEmail?email=${encodeURIComponent(
          payload.emailAddress
        )}`
      );

      const emailResult = emailResponse.data;
      const invalidEmailStatuses = [
        "undeliverable",
        "illegitimate",
        "unreachable",
      ];
      if (invalidEmailStatuses.includes(emailResult)) {
        fail("Email is not valid");
        return;
      }

      if (payload.telephone) {
        try {
          const telResponse = await axios.post(
            `${Settings.WWWENDPOINT
            }/verifyTelephone?telephone=${encodeURIComponent(
              payload.telephone
            )}`
          );
          const telResult = telResponse.data;
          const invalidTelephoneStatuses = ["unverified", "dead"];
          if (invalidTelephoneStatuses.includes(telResult)) {
            fail("Telephone is not valid");
            return;
          }
        } catch (telError) {
          fail("Telephone validation failed");
          return;
        }
      }

      const regResponse = await axios.post(
        `${getApiEndpoint()}api/account/register`,
        payload
      );
      cb(regResponse.data);
    } catch (error) {
      fail("Registration failed");
    }
  },
  forgotPassword(payload, cb) {
    axios
      .post(getApiEndpoint() + "api/account/forgot-password", payload)
      .then((response) => {
        cb(response.data);
      });
  },
  changePassword(payload, cb, fb) {
    axios
      .post(getApiEndpoint() + "api/account/change-password", payload)
      .then((response) => {
        cb(response.data);
      })
      .catch((response) => {
        fb(response);
      });
  },
  getSession(cb) {
    axios.get(getApiEndpoint() + "api/account/session").then((response) => {
      cb(response.data);
    });
  },
  getConfiguration(cb) {
    axios.get(`${Settings.WWWENDPOINT}/getConfiguration`).then((response) => {
      cb(response.data);
    });
  },

  passwordResetInitiate(payload, success, failure) {
    axios
      .post(getApiEndpoint() + "api/password/password-reset-initiate", payload)
      .then((response) => {
        success(response.data);
      })
      .catch((err) => {
        failure(err.response.data);
      });
  },

  passwordResetConfirm(payload, success, failure) {
    axios
      .post(getApiEndpoint() + "api/password/password-reset-confirm", payload)
      .then((response) => {
        success(response.data);
      })
      .catch((err) => {
        failure(err.response.data);
      });
  },

  passwordResetChange(payload, success, failure) {
    axios
      .post(getApiEndpoint() + "api/password/password-reset-change", payload)
      .then((response) => {
        success(response.data);
      })
      .catch((err) => {
        failure(err.response.data);
      });
  },
};
